// src/shared/api/services/BEX/redisService.ts
import {
    bexHttpClient
} from '../../clients';
import {
    CheckRedisClientRequest,
    CheckRedisClientAPIResponse
} from '../bexService.types';

/**
 * Service class for performing authentication operations.
 */
class RedisService {
    /**
     * check redis connection.
     * @returns {Promise<CheckRedisClientResponse>} The response from the server return success if connection is valid.
     */
    async checkRedisClient(data: CheckRedisClientRequest): Promise<CheckRedisClientAPIResponse> {
        const response = await bexHttpClient.post('/redis/client/check-redis-client', data);
        return response;
    }

}

const redisService = new RedisService();
export { redisService };